import { AchievementInfo } from "./AchievementInfoTypes";

// -----
// *** TOTAL ACHIEVEMENTS ***
// -----

export const Achievement_Total_Bricks_100: AchievementInfo = {
  id: "achievement_total_bricks_100",
  title: "Brick Beginner",
  description: "Collect 10,000 total bricks",
  category: "total",
  targetType: "total",
  threshold: 10000,
};

export const Achievement_Total_Bricks_1000: AchievementInfo = {
  id: "achievement_total_bricks_1000",
  title: "Brick Collector",
  description: "Collect 100,000 total bricks",
  category: "total",
  targetType: "total",
  threshold: 100000,
};

export const Achievement_Total_Bricks_10000: AchievementInfo = {
  id: "achievement_total_bricks_10000",
  title: "Brick Hoarder",
  description: "Collect 1,000,000 total bricks",
  category: "total",
  targetType: "total",
  threshold: 1000000,
};

export const Achievement_Total_Bricks_2500000: AchievementInfo = {
  id: "achievement_total_bricks_2500000",
  title: "Brick Enthusiast",
  description: "Collect 2,500,000 total bricks",
  category: "total",
  targetType: "total",
  threshold: 2500000,
};

export const Achievement_Total_Bricks_100000: AchievementInfo = {
  id: "achievement_total_bricks_100000",
  title: "Brick Master",
  description: "Collect 10,000,000 total bricks",
  category: "total",
  targetType: "total",
  threshold: 10000000,
};

export const Achievement_Total_Bricks_50000000: AchievementInfo = {
  id: "achievement_total_bricks_50000000",
  title: "Brick Magnate",
  description: "Collect 50,000,000 total bricks",
  category: "total",
  targetType: "total",
  threshold: 50000000,
};

export const Achievement_Total_Bricks_100000000: AchievementInfo = {
  id: "achievement_total_bricks_100000000",
  title: "Brick Tycoon",
  description: "Collect 100,000,000 total bricks",
  category: "total",
  targetType: "total",
  threshold: 100000000,
};

export const Achievement_Total_Bricks_250000000: AchievementInfo = {
  id: "achievement_total_bricks_250000000",
  title: "Brick Legend",
  description: "Collect 250,000,000 total bricks",
  category: "total",
  targetType: "total",
  threshold: 250000000,
};

export const Achievement_Total_Sets_10: AchievementInfo = {
  id: "achievement_total_sets_10",
  title: "Set Collector",
  description: "Purchase 1,000 total sets",
  category: "total",
  targetType: "total",
  threshold: 1000,
};

export const Achievement_Total_Sets_50: AchievementInfo = {
  id: "achievement_total_sets_50",
  title: "Set Enthusiast",
  description: "Purchase 5,000 total sets",
  category: "total",
  targetType: "total",
  threshold: 5000,
};

export const Achievement_Total_Sets_10000: AchievementInfo = {
  id: "achievement_total_sets_10000",
  title: "Set Connoisseur",
  description: "Purchase 10,000 total sets",
  category: "total",
  targetType: "total",
  threshold: 10000,
};

export const Achievement_Total_Sets_15000: AchievementInfo = {
  id: "achievement_total_sets_15000",
  title: "Set Aficionado",
  description: "Purchase 15,000 total sets",
  category: "total",
  targetType: "total",
  threshold: 15000,
};

export const Achievement_Total_Sets_20000: AchievementInfo = {
  id: "achievement_total_sets_20000",
  title: "Set Master",
  description: "Purchase 20,000 total sets",
  category: "total",
  targetType: "total",
  threshold: 20000,
};

export const Achievement_Total_Sets_30000: AchievementInfo = {
  id: "achievement_total_sets_30000",
  title: "Set Magnate",
  description: "Purchase 30,000 total sets",
  category: "total",
  targetType: "total",
  threshold: 30000,
};

export const Achievement_Total_Sets_40000: AchievementInfo = {
  id: "achievement_total_sets_40000",
  title: "Set Tycoon",
  description: "Purchase 40,000 total sets",
  category: "total",
  targetType: "total",
  threshold: 40000,
};

export const Achievement_Total_Sets_50000: AchievementInfo = {
  id: "achievement_total_sets_50000",
  title: "Set Legend",
  description: "Purchase 50,000 total sets",
  category: "total",
  targetType: "total",
  threshold: 50000,
};
